import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const JuniorExamination = () => {
  useEffect(() => {
    document.title = "Junior Examination -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Academics </li>
          <li>Examination Schedule & Scheme of Evaluation</li>
          <li>Junior Examination </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Junior Examination </h1>
              <h6>Scheme Of Evaluation </h6>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassesUkg-II.pdf"
                  target="_blank"
                >
                  {" "}
                  Classes Ukg-II
                </Link>{" "}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ClassesIII-V.pdf"
                  target="_blank"
                >
                  {" "}
                  Classes III-V
                </Link>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JuniorExamination;
